import React from 'react';

const SILAssessment = () => {
  const silLevels = [
    { level: "SIL 1", rrf: "10 - 100", availability: "90% - 99%", color: "bg-green-500" },
    { level: "SIL 2", rrf: "100 - 1000", availability: "99% - 99.9%", color: "bg-yellow-500" },
    { level: "SIL 3", rrf: "1000 - 10,000", availability: "99.9% - 99.99%", color: "bg-orange-500" },
    { level: "SIL 4", rrf: "10,000 - 100,000", availability: "99.99% - 99.999%", color: "bg-red-500" }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-900">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Safety Integrity Level (SIL) Assessment
          </h2>
          <p className="text-xl text-gray-300">How SIL is determined and applied</p>
        </div>
        
        <div className="bg-gray-800 p-8 rounded-lg mb-12">
          <h3 className="text-2xl font-bold text-white mb-6">SIL Determination Process</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="bg-blue-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                1
              </div>
              <h4 className="text-lg font-semibold text-white mb-2">Risk Analysis</h4>
              <p className="text-gray-300">Identify hazards and assess severity</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2
              </div>
              <h4 className="text-lg font-semibold text-white mb-2">Quantitative Calculations</h4>
              <p className="text-gray-300">Calculate required risk reduction factor</p>
            </div>
            <div className="text-center">
              <div className="bg-blue-600 text-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                3
              </div>
              <h4 className="text-lg font-semibold text-white mb-2">SIL Assignment</h4>
              <p className="text-gray-300">Determine appropriate SIL level</p>
            </div>
          </div>
        </div>
        
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">SIL Levels & Risk Reduction Factors</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {silLevels.map((sil, index) => (
              <div key={index} className="bg-gray-800 p-6 rounded-lg border-2 border-gray-700 hover:border-blue-500 transition-colors">
                <div className={`${sil.color} text-white text-center py-3 px-4 rounded-lg mb-4`}>
                  <h4 className="text-2xl font-bold">{sil.level}</h4>
                </div>
                <div className="space-y-3">
                  <div>
                    <p className="text-gray-400 text-sm">Risk Reduction Factor</p>
                    <p className="text-white font-semibold">{sil.rrf}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Availability</p>
                    <p className="text-white font-semibold">{sil.availability}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="relative">
          <img
            src="/assets/asset-21.jpg"
            alt="Data analysis graphs"
            className="w-full rounded-lg shadow-2xl opacity-80"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default SILAssessment;
